export default {
  headerTitle: 'Contributions',
};
